import React from "react";
import NewsletterForm from "components/NewsletterForm";
import Layout from "components/common/Layout";
import { usePageMeta } from "hooks";

const NewsletterPage = () => {
  usePageMeta("Newsletter sign-up");

  return (
    <Layout>
      <NewsletterForm />
    </Layout>
  );
};

export default NewsletterPage;
